import React from 'react';
import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import ActiveIcon from 'assets/svg/am-checkedmark.svg';
import NotActiveIcon from 'assets/svg/am-uncheckedmark.svg';


export interface AmenityCheckListItemProps {
  title: string;
  isActive: boolean;
  locator: string;
}

const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexBasis: 'calc( ( 100% - ( 32px * 3 ) ) / 4 )',
  maxWidth: 'calc( ( 100% - ( 32px * 3 ) ) / 4 )',
  flexGrow: 1,
  gap: theme.spacing(1),
  alignItems: 'center',
  [theme.media.createObjectMediaQuery({ at: 2 })]: {
    flexBasis: 'calc( ( 100% - ( 32px * 2 ) ) / 3 )',
    maxWidth: 'calc( ( 100% - ( 32px * 2 ) ) / 3 )',
  },
  [theme.media.createObjectMediaQuery({ at: 1 })]: {
    flexBasis: 'calc( ( 100% - 32px ) / 2 )',
    maxWidth: 'calc( ( 100% - 32px ) / 2 )',
  },
}));

const TitleStyled = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const AmenityCheckListItem: React.FC<AmenityCheckListItemProps> = (props) => (
  <Root data-auto-checklist-amenity-item={props.locator}>
    {props.isActive ? <ActiveIcon /> : <NotActiveIcon />}
    <TitleStyled>{props.title}</TitleStyled>
  </Root>
);
